export enum FacebookTargetingCategoryCode {
  Behaviors = "behaviors",
  Demographics = "demographics",
  Interests = "interests",
}

export class FacebookTargetingCategory {
  constructor(
    public readonly name: string,
    public readonly code: FacebookTargetingCategoryCode,
    public readonly type: string,
    public readonly classType: string,
  ) {}
}

export class FacebookTargetingType {
  constructor(
    public readonly name: string,
    public readonly id: string,
    public readonly type: string,
  ) {}
}
